import { ByteArrayContent2n0wb43y6ugs1 as ByteArrayContent } from './OutgoingContent.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { charset1dribv3ku48b1 as charset } from '../ContentTypes.mjs';
import { Charsets_getInstanceq0o82sizm30g as Charsets_getInstance } from '../../../../../ktor-ktor-io/io/ktor/utils/io/charsets/Charset.js.mjs';
import { toByteArray1i3ns5jnoqlv6 as toByteArray } from '../../../../../ktor-ktor-io/io/ktor/utils/io/core/Strings.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { take9j4462mea726 as take } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var TextContentClass;
function TextContent() {
  if (TextContentClass === VOID) {
    class $ extends ByteArrayContent() {
      constructor(text, contentType, status) {
        status = status === VOID ? null : status;
        super();
        this.t56_1 = text;
        this.u56_1 = contentType;
        this.v56_1 = status;
        var tmp = this;
        var tmp0_elvis_lhs = charset(this.u56_1);
        tmp.w56_1 = toByteArray(this.t56_1, tmp0_elvis_lhs == null ? Charsets_getInstance().r4l_1 : tmp0_elvis_lhs);
      }
      t47() {
        return this.u56_1;
      }
      u47() {
        return fromInt(this.w56_1.length);
      }
      i56() {
        return this.w56_1;
      }
      toString() {
        return 'TextContent[' + this.u56_1.toString() + '] "' + take(this.t56_1, 30) + '"';
      }
    }
    initMetadataForClass($, 'TextContent');
    TextContentClass = $;
  }
  return TextContentClass;
}
//region block: exports
export {
  TextContent as TextContent1rb6ftlpvl1d2,
};
//endregion

//# sourceMappingURL=TextContent.mjs.map
